"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Miniquote = void 0;
class Miniquote {
    constructor(obj) {
        // Take in an object, and assign every property from that
        // object onto this newly created object.
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.Miniquote = Miniquote;
//# sourceMappingURL=Miniquote.js.map